export const isNull = (value) => {
    return value === null;
};
export const isUndefined = (value) => {
    return typeof value === "undefined";
};
export const isNullable = (value) => {
    return isNull(value) || isUndefined(value);
};
// value != null は null | undefined のどちらでもないことを表す
export const isNonNullable = (value) => value != null;
export const isDeepUndefined = (v) => {
    if (isNull(v) || isUndefined(v)) {
        return true;
    }
    return Object.keys(v).every((key) => isUndefined(v[key]));
};
//# sourceMappingURL=empty-type-guards.js.map